import { render, staticRenderFns } from "./ny_zixun.vue?vue&type=template&id=660c4d3d&scoped=true&"
import script from "./ny_zixun.vue?vue&type=script&lang=js&"
export * from "./ny_zixun.vue?vue&type=script&lang=js&"
import style0 from "./ny_zixun.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ny_zixun.vue?vue&type=style&index=1&id=660c4d3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660c4d3d",
  null
  
)

export default component.exports